<script setup lang="ts">
import { ref, onMounted } from "vue";
import useAuthenticatedFetch from "@/components/frontend/composable/useAuthenticatedFetch";

const props = defineProps({
  tour: {
    required: true,
    type: String
  }
});

const { authenticatedFetch, isLoading } = useAuthenticatedFetch(props.tour);

const registrations = ref([]);

const fetchData = async() => {
  try {
    const response = await authenticatedFetch('registration');

    const { data } = await response.json();

    registrations.value = data;

  } catch (error) {
    console.error("Fetch Data Error:", error);
  }
};

onMounted(async () => {
  await fetchData();
})

</script>

<template>
  <template v-if="isLoading">
    <div class="justify-content-center">
      <div class="d-flex justify-content-center">
        <div class="spinner-border text-primary"></div>
      </div>
    </div>
  </template>
  <template v-else>
    <div>
      <template v-for="registration in registrations">
        <slot :registration="registration"></slot>
      </template>
    </div>
  </template>

</template>
<style scoped>

</style>
